import React from 'react';
import InputField from '../../Common/InputField';
import { HTMLTrans } from '../../Common/Translations';
import EPhotobookPublicShareLink from './EPhotobookPublicShareLink';

export const publicAccess = ({t, link, currentPage, index, title, previewImg}) => (
  <div key={`share-link-${index}-page-${currentPage}`}>
    <hr/>
      <div className="col justify-content-between pl-0 pb-2">
      <EPhotobookPublicShareLink t={t} link={link} title={title} previewImg={previewImg} isFullWidth={true} index={index} />
      </div>
  </div>
);

export const restrictedAccess = ({ t, newEmails, onEmailChange, onSubmit, disabled, index }) => (
  <div>
    <hr/>
    <div className="col justify-content-between pl-0 pb-2">
      <label className="ProximaNova-Bold">
        <HTMLTrans id="account.ephotobook_share_permission_title">Share with friends and family</HTMLTrans>
      </label>
      <div className="row pl-3">
        <div className="col-10 epb-col-8 p-0">
          <InputField
            id={`ephotobook-add-email-${index}`}
            placeholder={t("account.ephotobook_share_email", "Add people by email")}
            type='text'
            value={newEmails}
            onChange={onEmailChange}
            formClass='form-group mb-0'
            labelClass='form-control-label'
          />
        </div>
        <div className="col-2">
        <button
          type="button"
          onClick={() => onSubmit()}
          className="btn btn-outline-primary"
          disabled={disabled}
        >
          <HTMLTrans id="account.ephotobook_add_email">Add</HTMLTrans>
        </button>
        </div>
      </div>
      <p className="text-gray small mt-1 pl-1">
        <HTMLTrans id="account.ephotobook_share_email_description">Separate multiple email addresses with a comma.</HTMLTrans>
      </p>
    </div>
  </div>
);

export const ephotobookAccessData = ({
  newEmails,
  deletedEmails,
  countryCode,
  selectedAccessType: { code, emails },
  fileLink: { file },
}) => {
  const updatedEmails = (emails.length > 0) ? emails.filter(email => !deletedEmails.includes(email)) : [];
  let latest = [];

  if (newEmails && newEmails.length > 0) {
    const listEmails = newEmails.split(',').map(e => e.trim());
    const lists = updatedEmails.concat(listEmails).filter(Boolean);
    latest = new Set(lists);
  }

  const finalEmailList = newEmails.length > 0 ? [...latest] : (updatedEmails.length < 1 ? [...latest] : updatedEmails);
  return ({
    store_code: countryCode,
    access_type_code: code,
    file: file,
    emails: finalEmailList,
  });
};



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/EphotobookAccess.js